// Define YouTube reset function FIRST at global scope
// This ensures v2pdp.js can always access it, even before DOMContentLoaded
window.resetYouTubeVideos = function () {
  document
    .querySelectorAll(".product-media-image__youtube-wrapper")
    .forEach((w) => (w.style.display = "block"));
  document
    .querySelectorAll(".product-media-image__video-container")
    .forEach((c) => (c.style.display = "none"));
  document
    .querySelectorAll(".product-media-image__video-iframe")
    .forEach((iframe) => {
      if (iframe.src) {
        iframe.src = "";
      }
    });
  // Remove the style attribute completely when videos are paused/reset
  const featuredSlider = document.querySelector(
    ".product-media-image--featured"
  );
  if (featuredSlider) featuredSlider.removeAttribute("style");
};

document.addEventListener("DOMContentLoaded", function () {
  handleProductMediaSkeleton();
  handleSafetyRatedPopUp();
  // Add badge on initial load after DOM is ready
  window.addSafetyBadgeToFirstSlide();
});

// Also try immediate execution in case DOM is already loaded
if (document.readyState !== "loading") {
  // DOM already loaded, call handleSafetyRatedPopUp immediately
  handleSafetyRatedPopUp();
}

/**
 * Check if Safety Rated badge should be shown based on settings
 */
window.shouldShowSafetyBadge = function () {
  const wrapper = document.querySelector(".product-media-images-wrapper");
  if (!wrapper) return false;

  // Check if feature is enabled in theme settings
  const isEnabled = wrapper.dataset.safetyBadgeEnabled === "true";
  return isEnabled;
};

/**
 * Add Safety Rated badge to the first image slide
 * This function is called after slide filtering to ensure badge appears on correct slide
 */
window.addSafetyBadgeToFirstSlide = function () {
  // Check if badge should be shown based on settings
  if (!window.shouldShowSafetyBadge()) {
    return;
  }

  const featuredSlider = document.querySelector(
    ".product-media-image--featured"
  );
  if (!featuredSlider) return;

  const slides = featuredSlider.querySelectorAll(".swiper-slide");
  if (!slides || slides.length === 0) return;

  // Find the first image slide (not a video slide)
  const firstImageSlide = Array.from(slides).find((slide) => {
    const hasImage = slide.querySelector(".product-media-image__img-wrapper");
    const isVideoSlide = slide.querySelector(
      ".product-media-image__youtube-wrapper"
    );
    return hasImage && !isVideoSlide;
  });

  if (!firstImageSlide) return;

  // Remove any existing badges from all slides first to avoid duplicates
  slides.forEach((slide) => {
    const existingBadge = slide.querySelector(".product-media-image__badge");
    if (existingBadge) {
      existingBadge.remove();
    }
  });

  // Check if badge already exists on this slide
  if (firstImageSlide.querySelector(".product-media-image__badge")) {
    return;
  }

  // Create and append the Safety Rated badge
  const badge = document.createElement("button");
  badge.id = "safety-rated-badge";
  badge.className = "product-media-image__badge";
  badge.type = "button";
  badge.setAttribute("aria-label", "Safety Rated and ANSI Z87.1 Certified");

  badge.innerHTML = `
      <span class="safety-rated--badge">SAFETY RATED</span>
      <span class="ansi--badge">
        ANSI Z87.1
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M13.3346 4L6.0013 11.3333L2.66797 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    `;

  firstImageSlide.appendChild(badge);
};

function handleProductMediaSkeleton() {
  // console.log('Initializing product media skeleton handling');

  const loadingSkeleton = document.querySelector(
    ".product-media-images__loading"
  );
  const featuredSlider = document.querySelector(
    ".product-media-image--featured"
  );
  const thumbnailWrapper = document.querySelector(
    ".product-media-images__thumbnail-wrapper"
  );

  // Function to hide skeleton - will be called after filtering completes
  window.hideProductMediaSkeleton = () => {
    // console.log('Hiding skeleton after filtering complete');
    if (loadingSkeleton) loadingSkeleton.style.display = "none";
    if (featuredSlider)
      featuredSlider.classList.remove("product-media-image--loading");
    if (thumbnailWrapper)
      thumbnailWrapper.classList.remove(
        "product-media-images__thumbnail-wrapper--loading"
      );

    // Add safety badge after skeleton is hidden
    window.addSafetyBadgeToFirstSlide();
  };

  // Initialize Swipers with skeleton still showing
  // Store globally so v2pdp.js can re-attach event listeners after rebuild
  window.productMediaFeaturedSwiper = new Swiper(
    ".product-media-image--featured",
    {
      slidesPerView: 1,
      spaceBetween: 10,
      // Enable click events and allow propagation for safety badge
      simulateTouch: true,
      touchEventsTarget: "wrapper",
      preventClicks: false,
      preventClicksPropagation: false,
      navigation: {
        nextEl: ".swiper-button-next.product-media-image__swiper-button-next",
        prevEl: ".swiper-button-prev.product-media-image__swiper-button-prev",
      },
      thumbs: {
        swiper: {
          el: ".product-media-image--thumbnail",
          slidesPerView: 5,
          spaceBetween: 5,
          watchSlidesProgress: true,
        },
      },
      on: {
        init: function () {
          // console.log('Swiper initialized - ready for filtering');
          // Signal that swiper is ready for filtering
          window.productMediaSwiperReady = true;

          console.log(
            "[SLIDE]",
            swiper.activeIndex,
            new URL(window.location.href).toString()
          );
        },
        // Don't interfere with safety badge clicks
        click: function (swiper, event) {
          // If clicking on badge, let it propagate normally
          if (event.target.closest(".product-media-image__badge")) {
            return; // Don't interfere with badge popup
          }
        },
      },
    }
  );

  // Fallback: Hide skeleton after timeout if filtering doesn't complete
  setTimeout(() => {
    if (loadingSkeleton && loadingSkeleton.style.display !== "none") {
      // console.log('Fallback: Force hiding skeleton after timeout');
      window.hideProductMediaSkeleton();
    }
  }, 3000);

  // YouTube functionality (only if delegation is not provided by v2PdpJs)
  if (!window.__v2PdpDelegatedYT) {
    const playButtons = document.querySelectorAll(
      ".product-media-image__youtube-wrapper button"
    );
    playButtons.forEach((button) => {
      button.addEventListener("click", function (e) {
        e.stopPropagation();
        const videoId = this.getAttribute("data-video-id");
        const slide = this.closest(".product-media-image__slide");
        const wrapper = this.closest(".product-media-image__youtube-wrapper");
        const videoContainer = slide.querySelector(
          ".product-media-image__video-container"
        );
        const iframe = slide.querySelector(
          ".product-media-image__video-iframe"
        );
        if (videoId && iframe) {
          iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&showinfo=0`;
          wrapper.style.display = "none";
          videoContainer.style.display = "block";
          const featuredSlider = document.querySelector(
            ".product-media-image--featured"
          );
          if (
            featuredSlider &&
            window.matchMedia("(min-width: 560px)").matches
          ) {
            if (window.matchMedia("(min-width:560px)").matches) {
              featuredSlider.style.height = "430px";
            }
          }
        }
      });
    });
  }

  // Attach YouTube reset handler to slideChange event
  // Function is already defined globally at the top of the file
  if (
    window.productMediaFeaturedSwiper &&
    typeof window.resetYouTubeVideos === "function"
  ) {
    window.productMediaFeaturedSwiper.on(
      "slideChange",
      window.resetYouTubeVideos
    );
  }
}

/**
 * Handle Safety Rated popup using event delegation
 * This works even when badge is dynamically created/recreated
 */
function handleSafetyRatedPopUp() {
  const popupTemplate = document.getElementById("safety-rated-popup-template");
  if (!popupTemplate) return;

  // Store the element that triggered the popup for focus restoration
  let triggerElement = null;

  // Wait for featured slider to be in DOM
  const attachHandler = () => {
    const featuredSlider = document.querySelector(
      ".product-media-image--featured"
    );

    if (!featuredSlider) {
      // Retry on next frame if not ready
      requestAnimationFrame(attachHandler);
      return;
    }

    // Attach click handler to parent (event delegation) with capture phase
    featuredSlider.addEventListener(
      "click",
      function (e) {
        const badge = e.target.closest(".product-media-image__badge");
        if (!badge) return;

        e.preventDefault();
        e.stopPropagation();

        // Store trigger element for focus restoration
        triggerElement = badge;

        // Clone and insert popup
        const popupContent = popupTemplate.content.cloneNode(true);
        document.body.appendChild(popupContent);

        const popup = document.querySelector(".safety-rated-popup");
        const overlay = popup.querySelector(".safety-rated-popup__overlay");
        const closeBtn = popup.querySelector(".safety-rated-popup__close");
        const popupContentEl = popup.querySelector(
          ".safety-rated-popup__content"
        );

        // Get all focusable elements for keyboard trap
        const focusableElements = popupContentEl.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        );
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        // Show popup
        requestAnimationFrame(() => {
          popup.classList.add("is-visible");
          // Focus close button for accessibility
          closeBtn.focus();
        });

        // Trap focus within popup
        const trapFocus = (e) => {
          if (e.key === "Tab") {
            if (e.shiftKey) {
              // Shift + Tab
              if (document.activeElement === firstFocusable) {
                e.preventDefault();
                lastFocusable.focus();
              }
            } else {
              // Tab
              if (document.activeElement === lastFocusable) {
                e.preventDefault();
                firstFocusable.focus();
              }
            }
          }
        };

        // Close handlers
        const closePopup = () => {
          popup.classList.remove("is-visible");

          // Remove focus trap
          popup.removeEventListener("keydown", trapFocus);

          // Restore focus to trigger element
          setTimeout(() => {
            popup.remove();
            if (triggerElement) {
              triggerElement.focus();
            }
          }, 300);
        };

        // Attach focus trap
        popup.addEventListener("keydown", trapFocus);

        closeBtn.addEventListener("click", closePopup);
        overlay.addEventListener("click", closePopup);

        // ESC key to close
        const handleEsc = (e) => {
          if (e.key === "Escape") {
            closePopup();
            document.removeEventListener("keydown", handleEsc);
          }
        };
        document.addEventListener("keydown", handleEsc);
      },
      true
    ); // Use capture phase to intercept before Swiper
  };

  // Start attaching handler
  attachHandler();
}
